if (document.querySelector('#rodzaj-pakietu-input')) {
    const rodzajPakietuVal = document.querySelector('#rodzaj-pakietu-input').value;
    
    const rodzajPakietu = rodzajPakietuVal.replace(/-/g, '_');
    const zawartoscPakietuPanel = document.querySelectorAll('[data-package-detail] .offcanvas');
    zawartoscPakietuPanel.forEach(panel => {
        panel.addEventListener('show.bs.offcanvas', (e) => {
            const zawartoscID = e.target.dataset.zawartosc;
            const zawartoscJSON = pakietZawartosc[rodzajPakietu][zawartoscID];
            const panelBody = panel.querySelector('.offcanvas-body');
            
            gtm_open_offcanvas(zawartoscID);

            let panelHTML = '';

            for (const [key, value] of Object.entries(zawartoscJSON)) {
                panelHTML += '<div class="wp-pakiet-zawartosc" style="margin-bottom:1rem;">';
                if (key !== 'global') {
                    panelHTML += `<h6 style="margin-bottom:8px;">${key}</h6>`;
                }

                const itemsObj = value;
                for (const [key, value] of Object.entries(itemsObj)) {
                    panelHTML += '<div class="wp-icon-box" style="gap:4px;">';
                    panelHTML += '<svg class="svg-icon" width="12" height="12" aria-hidden="true" role="img" focusable="false" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 11 8.499"><path id="Path_2" data-name="Path 2" d="M12.736,3.97a.733.733,0,0,1,1.047,0,.755.755,0,0,1,.01,1.05L7.88,12.01a.733.733,0,0,1-1.065.02l-3.6-3.646a.757.757,0,0,1,0-1.06.733.733,0,0,1,1.047,0l3.052,3.093,5.4-6.425.02-.022Z" transform="translate(-3.001 -3.75)" fill="#30a829"></path></svg>';
                    panelHTML += `<div class="wp-icon-box-desc">${value}</div>`;
                    panelHTML += '</div>';
                }
                panelHTML += '</div>';
            }

            panelBody.innerHTML = panelHTML;
        })
    })

    const gtm_open_offcanvas = (category_id) => {
        if (typeof gtag === 'function') {
            gtag("event", "click_detail", {
                detail_category_id: category_id
            });
            console.log(category_id);
        } else {
            console.log(category_id);
        }
    }
}